import React from 'react';
import { Input, type InputProps } from '@/components/atoms/Input';
import { Textarea, type TextareaProps } from '@/components/atoms/Textarea';
import styles from './FormField.module.scss';

export interface FormFieldProps {
  type?: 'input' | 'textarea';
  label: string;
  error?: string;
  helperText?: string;
  isRequired?: boolean;
  className?: string;
  inputProps?: Omit<InputProps, 'label' | 'error' | 'helperText' | 'isRequired'>;
  textareaProps?: Omit<TextareaProps, 'label' | 'error' | 'helperText' | 'isRequired'>;
}

export function FormField({
  type = 'input',
  label,
  error,
  helperText,
  isRequired,
  className,
  inputProps,
  textareaProps,
}: FormFieldProps) {
  const fieldClasses = [
    styles.formField,
    error && styles.hasError,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={fieldClasses}>
      {type === 'input' && (
        <Input
          label={label}
          error={error}
          helperText={helperText}
          isRequired={isRequired}
          {...inputProps}
        />
      )}
      
      {type === 'textarea' && (
        <Textarea
          label={label}
          error={error}
          helperText={helperText}
          isRequired={isRequired}
          {...textareaProps}
        />
      )}
    </div>
  );
}

export default FormField;